import { render, staticRenderFns } from "./knowledgeBaseList.vue?vue&type=template&id=62dbdf64"
import script from "./knowledgeBaseList.vue?vue&type=script&lang=js"
export * from "./knowledgeBaseList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBaseList.vue?vue&type=style&index=0&id=62dbdf64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports